import "./App.css";
import Header from "./components/global/Header";
import Homepage from "./components/global/Homepage";
import About from "./components/global/About";
import GettoAvax from "./components/global/GettoAvax";
import GettoBase from "./components/global/GettoBase";
import GettoPolygon from "./components/global/GettoPolygon";
import Airdrop from "./components/global/Airdrop";
import Roadmap from "./components/global/RoadmapTimeline";
import Contact from "./components/global/Contact";
import Footer from "./components/global/Footer";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <div className="page">
      <Header />
      <div className="content">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gettoavax" element={<GettoAvax />} />
          <Route path="/gettobase" element={<GettoBase />} />
          <Route path="/gettopolygon" element={<GettoPolygon />} />
          <Route path="/airdrop" element={<Airdrop />} />
          <Route path="/roadmap" element={<Roadmap />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
